import { actionsReducer } from "./actions";
import { docgroupsReducer, doctypesReducer, metatypesReducer } from "./docgroups";
import { favoriteDocumentsReducer } from "./documents";
import { dossiersReducer, dossiertypesReducer } from "./folders";
import { contentReducer, languageReducer, notificationReducer } from "./general";
import { colleaguesReducer, userdataReducer, usersReducer } from "./user";

const allReducers = {reducer: {
    language: languageReducer,
    content: contentReducer,
    userdata: userdataReducer,
    users: usersReducer,
    notification: notificationReducer,

    favoriteDocuments: favoriteDocumentsReducer,

    docgroups: docgroupsReducer,
    doctypes: doctypesReducer,
    metatypes: metatypesReducer,

    dossiers: dossiersReducer,
    dossiertypes: dossiertypesReducer,

    actions: actionsReducer,
    colleagues: colleaguesReducer
}}

export default allReducers;